class CareerFormValidator {
  constructor({ formSelector = '#career-form', submitSelector = 'button[type="submit"]' } = {}) {
    this.form = CareerFormValidator.resolveForm(formSelector);
    this.submitBtn = this.form ? this.form.querySelector(submitSelector) : null;
    this.errorBox = null;
  }

  // Retrouve le form même si l’ID HTML a été écrit id="#career-form"
  static resolveForm(sel) {
    if (sel && typeof sel === 'object' && sel.nodeType === 1) return sel;

    const candidates = [];
    if (typeof sel === 'string' && sel.trim()) candidates.push(sel.trim());

    candidates.push(
      '#career-form',
      '[id="#career-form"]',
      '#career-form-form',
      'section.career-form form',
      'form.space-y-8'
    );

    for (const s of candidates) {
      try {
        const el = document.querySelector(s);
        if (el) return el;
      } catch {}
    }
    return null;
  }

  // ✅ AJOUT: permet de ne pas valider les champs "required" cachés (ex: job_type quand #job-type est display:none)
  isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  addLiveValidation() {
    if (!this.form) return;
    const fields = this.form.querySelectorAll('[required], [data-required]');
    fields.forEach(field => {
      const evt = field.type === 'file' ? 'change' : 'blur';
      field.addEventListener(evt, () => this.validateField(field));
    });

    // Format tel au blur
    this.form.querySelectorAll('input[type="tel"]').forEach(input => {
      input.addEventListener('blur', () => {
        const cleaned = (input.value || '').replace(/\D/g, '');
        if (cleaned.length === 10) {
          input.value = `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`;
        }
      });
    });
  }

  init() {
    if (!this.form) return;

    this.createErrorBox();
    this.addLiveValidation();

    // Intercepte le submit
    this.form.setAttribute('novalidate', 'novalidate');
    this.form.addEventListener(
      'submit',
      (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.hideError();

        const isValid = this.validateForm();
        if (isValid) this.sendForm();
        return false;
      },
      true
    );
  }

  validateForm() {
    let isValid = true;
    const requiredFields = this.form.querySelectorAll('[required], [data-required]');

    requiredFields.forEach((field) => {
      // ✅ AJOUT: si le champ (ou son parent) est caché, on l’ignore (ex: job_type)
      if (!this.isVisible(field)) return;

      const isCheckbox = field.type === 'checkbox';
      const isEmail = field.type === 'email';
      const isTel = field.type === 'tel';
      const isFile = field.type === 'file';
      const value = (field.value || '').trim();

      const isEmpty = isFile ? (field.files?.length === 0) : (isCheckbox ? !field.checked : !value);
      const isEmailInvalid = isEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      const isPhoneInvalid = isTel && !/^\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4}$/.test(value);

      const isCvFile = isFile && field.name === 'cv_file';
      let isInvalidCvFile = false;
      if (isCvFile && field.files && field.files.length > 0) {
        const ext = field.files[0].name.split('.').pop().toLowerCase();
        isInvalidCvFile = !['pdf', 'txt'].includes(ext);
      }

      const hasError = isEmpty || isEmailInvalid || isPhoneInvalid || isInvalidCvFile;
      if (hasError) isValid = false;

      this.validateField(field); // feedback visuel
    });

    return isValid;
  }

  validateField(field) {
    // ✅ AJOUT: ne pas afficher d’erreur sur un champ caché
    if (!this.isVisible(field)) {
      // supprime un éventuel message existant
      const errorId =
        `${field.name || (field.placeholder || 'field').replace(/\s+/g, '-').toLowerCase()}-error`;
      const errorEl = document.getElementById(errorId);
      if (errorEl) errorEl.remove();
      // nettoie styles inline si besoin
      field.style.removeProperty('border');
      field.style.removeProperty('color');
      return;
    }

    const isCheckbox = field.type === 'checkbox';
    const isEmail = field.type === 'email';
    const isTel = field.type === 'tel';
    const isFile = field.type === 'file';
    const isCvFile = field.name === 'cv_file';
    const value = (field.value || '').trim();

    const isEmpty = isFile ? (field.files?.length === 0) : (isCheckbox ? !field.checked : !value);
    const isEmailInvalid = isEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    const isPhoneInvalid = isTel && !/^\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4}$/.test(value);

    let isInvalidCvFile = false;
    if (isFile && field.files && field.files.length > 0) {
      const ext = field.files[0].name.split('.').pop().toLowerCase();
      isInvalidCvFile = isCvFile && !['pdf', 'txt'].includes(ext);
    }

    const errorId =
      `${field.name || (field.placeholder || 'field').replace(/\s+/g, '-').toLowerCase()}-error`;
    let errorEl = document.getElementById(errorId);
    const hasError = isEmpty || isEmailInvalid || isPhoneInvalid || isInvalidCvFile;

    if (hasError) {
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.id = errorId;
        errorEl.textContent =
          isCheckbox ? 'You must accept to continue'
          : isEmail && !isEmpty ? 'Please enter a valid email address'
          : isTel && !isEmpty ? 'Please enter a valid phone number'
          : isInvalidCvFile ? 'Only PDF or TXT files are allowed for the CV'
          : 'This field is required';
        Object.assign(errorEl.style, { color:'#ff5e57', fontSize:'13px', marginTop:'4px' });
        const parent = isCheckbox ? field.closest('label')?.parentElement || field.parentElement : field;
        parent.insertAdjacentElement('afterend', errorEl);
      }
      if (!isFile) {
        field.style.setProperty('border', '1px solid #ff5e57', 'important'); // rouge
        field.style.setProperty('color',  '#ff5e57', 'important');
      }
    } else {
      if (errorEl) errorEl.remove();
      if (!isFile) {
        field.style.setProperty('border', '1px solid #34D399', 'important'); // vert
        field.style.setProperty('color',  '#34D399', 'important');
      }
      if (isTel) {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned.length === 10) {
          field.value = `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`;
        }
      }
    }
  }

  async sendForm() {
    const formData = new FormData(this.form);

    // Récupère/Crée le loader (overlay body, z-index élevé)
    let loader = document.getElementById('form-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'form-loader';
      loader.className = 'fixed inset-0 z-[9999] hidden flex items-center justify-center bg-black/50';
      loader.innerHTML = '<div class="h-12 w-12 rounded-full border-4 border-white/30 border-t-white animate-spin"></div>';
      document.body.appendChild(loader);
    }

    // Message de confirmation : utilise le toast PROLAB existant.
    const storeForToast = (this.form.querySelector('[name="store"]')?.value || 'sinto')
      .trim().toLowerCase();
    let success = storeForToast === 'prolab'
      ? (this.form.closest('.pcb')?.querySelector('#form-toast') || document.getElementById('form-toast'))
      : document.getElementById('success-message');

    if (!success) {
      success = document.createElement('div');
      success.id = 'success-message';
      document.body.appendChild(success);
    }

    if (storeForToast !== 'prolab') {
      success.className = 'fixed top-10 right-6 z-[10000] hidden bg-green-100 text-teal-900 rounded text-base px-6 py-3 shadow-lg';
      success.textContent = '✅ Message sent successfully!';
    }

    // Bouton submit : état loading
    if (this.submitBtn) {
      this.submitBtn.dataset.state = 'loading';
      this.submitBtn.setAttribute('disabled', 'disabled');
    }

    // Affiche loader
    loader.classList.remove('hidden');

    // Identifie la boutique depuis le formulaire Liquid, sans modifier SINTO.
    const store = (this.form.querySelector('[name="store"]')?.value || 'sinto')
      .trim().toLowerCase();
    const destinationEmail = (this.form.querySelector('[name="customer-email"]')?.value || '')
      .trim();

    formData.set('store', store);
    if (store === 'prolab') {
      if (!destinationEmail) {
        this.showError('Adresse de destination PROLAB manquante dans Customize.');
        loader.classList.add('hidden');
        if (this.submitBtn) this.submitBtn.removeAttribute('disabled');
        return;
      }
      formData.set('customer-email', destinationEmail);
    }

    try {
      const res = await fetch('https://sinto-one-prolab-327c8bdb5bc4.herokuapp.com/public-api/send-resume', {
        method: 'POST',
        body: formData
      });

      let data = null;
      try { data = await res.json(); } catch (e) { console.warn('[CFV] JSON parse failed'); }

      const ok = (res.ok && (data?.success === true || data == null));
      if (ok) {
        if (store === 'prolab') {
          success.textContent = '✓ Votre candidature a été envoyée avec succès !';
          success.classList.add('show');
          success.setAttribute('role', 'status');
          success.setAttribute('aria-live', 'polite');
          setTimeout(() => success.classList.remove('show'), 5000);
        } else {
          success.classList.remove('hidden');
          success.classList.add('fade-in-out');
          setTimeout(() => {
            success.classList.add('hidden');
            success.classList.remove('fade-in-out');
          }, 2000);
        }

        this.form.reset();
        this.form.querySelectorAll('[required], [data-required]').forEach(f => {
          f.style.removeProperty('border');
          f.style.removeProperty('color');
        });

        if (this.submitBtn) {
          this.submitBtn.dataset.state = 'success';
          setTimeout(() => { this.submitBtn.dataset.state = ''; }, 1000);
        }
      } else {
        this.showError((data && data.message) || 'Something went wrong.');
        if (this.submitBtn) {
          this.submitBtn.dataset.state = 'error';
          setTimeout(() => { this.submitBtn.dataset.state = ''; }, 1000);
        }
      }
    } catch (err) {
      console.error('❌ Error:', err);
      this.showError('Network error. Please try again later.');
      if (this.submitBtn) {
        this.submitBtn.dataset.state = 'error';
        setTimeout(() => { this.submitBtn.dataset.state = ''; }, 1000);
      }
    } finally {
      loader.classList.add('hidden'); // cache loader
      if (this.submitBtn) this.submitBtn.removeAttribute('disabled');
    }
  }

  createErrorBox() {
    this.errorBox = document.createElement('div');
    this.errorBox.id = 'career-error-box';
    this.errorBox.textContent = '';
    Object.assign(this.errorBox.style, {
      position: 'fixed',
      top: '20px',
      right: '-500px',
      backgroundColor: '#3b0a0a',
      color: '#fca5a5',
      padding: '10px 20px',
      zIndex: '10001',
      borderRadius: '12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      transition: 'right 0.4s ease'
    });
    document.body.appendChild(this.errorBox);
  }

  showError(msg) {
    if (!this.errorBox) this.createErrorBox();
    this.errorBox.textContent = msg;
    this.errorBox.style.right = '20px';
    // petit auto-hide
    setTimeout(() => { if (this.errorBox) this.errorBox.style.right = '-500px'; }, 3000);
  }

  hideError() {
    if (!this.errorBox) return;
    this.errorBox.style.right = '-500px';
  }
}

// Boot
document.addEventListener('DOMContentLoaded', () => {
  new CareerFormValidator({ formSelector: '#career-form' }).init();
});
